import { render } from "./ShopifyPage.vue?vue&type=template&id=33938f1a"
import script from "./ShopifyPage.vue?vue&type=script&lang=js"
export * from "./ShopifyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__